// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__cXP6h","cContent":"App_cContent__OP+2p"};